<script lang="ts">
    import type {ChatMessageAttachmentData} from "../../Types";
    import type {Document} from "./Types";
    import {authBlobUrl} from "../../Auth";
    import InView from "../InView.svelte";
    export let attachments: ChatMessageAttachmentData[]
    export let entity: Document
</script>

"{entity.file_name}" <br/>
{#if attachments && attachments.length}
    {#each attachments as attachment}
        {#if attachment.telegram_remote_attachment_id == entity.document.remote.id}
            {#if attachment.status === 'pending'}
                Документ ще не викачаний
            {:else if attachment.status === 'failed'}
                Документ викачати не вдалось
            {:else if attachment.status === 'success'}
                <InView>
                {#await authBlobUrl('/attachments/'+attachment.id)}
                    <div class="spinner-grow"></div>
                {:then src}
                    {#if src}
                        <a href="{src}"
                           target="_blank"
                           type="{entity.mime_type}"
                           download="{entity.file_name}">{entity.file_name}</a>
                    {:else}
                        Не вдалось завантажити.
                    {/if}
                {:catch error}
                    Не вдалось завантажити.
                {/await}
                </InView>
            {/if}
        {/if}
    {/each}
{:else}
    Не викачано
{/if}
